import React from "react";
import { Field, Formik, Form } from "formik";
import { FormGroup, FormControl } from "react-bootstrap";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { createAccountInformation } from "../../actions/Users";
import RippleButton from "./RippleButton";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("*Invalid email").required("*Email is Required"),
  name: Yup.string().required("*Name is Required"),
  company: Yup.string().required("*Company name is Required"),
});

const AccountInformation = ({ onSubmit, createAccountInformation }) => {
  const handleSubmit = (params) => {
    onSubmit();
    createAccountInformation(params);
  };

  return (
    <Formik
      initialValues={{
        name: "",
        email: "",
        company: "",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form className="onboarding-form text-center bg-white">
          <p className="onboarding-plan-name text-left">Account Information</p>
          <p className="onboarding-form-note text-left">
            Eliminate the hassle, cost, and risk of single-use paper menus.
          </p>
          <Field name="name">
            {({ field }) => (
              <FormGroup controlId="name" className="onboarding-form-group">
                <FormControl
                  type="text"
                  placeholder="Name"
                  onChange={field.onChange}
                  value={field.value}
                  data-prop="name"
                  isValid={touched.name && !errors.name}
                  isInvalid={touched.name && errors.name}
                  data-testid="onboarding-input-name"
                  className="onboarding-input"
                />
                <FormControl.Feedback type="invalid" className="text-left">
                  {errors.name}
                </FormControl.Feedback>
              </FormGroup>
            )}
          </Field>
          <Field name="email">
            {({ field }) => (
              <FormGroup controlId="email" className="onboarding-form-group">
                <FormControl
                  type="email"
                  placeholder="Email"
                  onChange={field.onChange}
                  value={field.value}
                  data-prop="email"
                  isValid={touched.email && !errors.email}
                  isInvalid={touched.email && errors.email}
                  data-testid="onboarding-input-email"
                  className="onboarding-input"
                />
                <FormControl.Feedback type="invalid" className="text-left">
                  {errors.email}
                </FormControl.Feedback>
              </FormGroup>
            )}
          </Field>
          <Field name="company">
            {({ field }) => (
              <FormGroup controlId="company" className="onboarding-form-group">
                <FormControl
                  type="text"
                  placeholder="Company"
                  onChange={field.onChange}
                  value={field.value}
                  data-prop="company"
                  isValid={touched.company && !errors.company}
                  isInvalid={touched.company && errors.company}
                  data-testid="onboarding-input-company"
                  className="onboarding-input"
                />
                <FormControl.Feedback type="invalid" className="text-left">
                  {errors.company}
                </FormControl.Feedback>
              </FormGroup>
            )}
          </Field>
          <RippleButton customStyles="mt-3" type testid="submit-account-info">
            Continue
          </RippleButton>
        </Form>
      )}
    </Formik>
  );
};

AccountInformation.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  createAccountInformation: PropTypes.func.isRequired,
};

export default connect(null, { createAccountInformation })(AccountInformation);
